export function downloadXML(invoices) {
    
    const {create} = require('xmlbuilder2');
    console.log(invoices);

    const xml = create('miniMAXUvozKnjigovodstvo', { 
        '@xmlns': 'http://moj.minimax.si/ip/doc/schemas/miniMAXUvozKnjigovodstvo', 
        '@xmlns:xsi': 'http://www.w3.org/2001/XMLSchema-instance', 
        '@xsi:schemaLocation': 'http://moj.minimax.si/ip/doc/schemas/miniMAXUvozKnjigovodstvo http://moj.minimax.si/ip/doc/schemas/miniMAXUvozKnjigovodstvo.xsd' 
    });
    const stranke = xml.root().ele('Stranke');
    const temeljnice = xml.root().ele('Temeljnice');

    invoices.forEach(invoice => {
        let kontoTerjatev = 0;
        let kontoPrihodkov = 0;
        let netAmount = 0;
        let taxAmount = 0;
        let ttAmount = 0;
        let grossAmount = 0;
        let kontoNaciniPlacila = 0;

        if (invoice.paymentMethods[0].title == 'Booking.com'){
            kontoNaciniPlacila = 16501;
        }else if(invoice.paymentMethods[0].title == 'Airbnb.com'){
            kontoNaciniPlacila = 16502;
        }else if(invoice.paymentMethods[0].title == 'Kartica / Card'){
            kontoNaciniPlacila = 1652;
        }else if (invoice.paymentMethods[0].title == 'Gotovina / Cash'){
            kontoNaciniPlacila = 1000;
        }else if (invoice.paymentMethods[0].title == 'PayPal'){
            kontoNaciniPlacila = 16500;
        }else if (invoice.paymentMethods[0].title == 'Nakazilo na TRR' && invoice.payer.country != 'SI'){
            kontoNaciniPlacila = 1211;
        }else if (invoice.paymentMethods[0].title == 'Nakazilo na TRR' && invoice.payer.country == 'SI'){
            kontoNaciniPlacila = 1200;
        }
        

        invoice.services.forEach(s => {
            if(s.taxRate == 9.5){
                netAmount += Math.round(s.price * (100 / (100 + s.taxRate)) * s.quantity * 100 + Number.EPSILON) / 100;
                taxAmount += Math.round(s.price * s.taxRate / (100 + s.taxRate) * s.quantity * 100 + Number.EPSILON) / 100;
            }
            if(s.taxRate == 0){
                ttAmount += s.price * s.quantity;
            }
            grossAmount += s.price * s.quantity;
        });

        if(invoice.payer.vat){
            if (invoice.payer.country != 'SI'){
                kontoTerjatev = 1211;
                kontoPrihodkov = 76111;
            }else{
                kontoTerjatev = 1200;
                kontoPrihodkov = 76001;
            }
        }else{
            kontoTerjatev = 1200;
            kontoPrihodkov = 76001;
        }
        
        
        // Create Stranka element
        const stranka = stranke.ele('Stranka');
        if(invoice.payer.vat){
            stranka.ele('Sifra').txt(invoice.index);
            stranka.ele('Naziv').txt(invoice.payer.title);
            stranka.ele('Naslov').txt(invoice.payer.address);
            stranka.ele('PostnaStevilka').txt('PO');
            stranka.ele('NazivPoste').txt(invoice.payer.city);
            stranka.ele('DavcniZavezanec').txt('D');
            stranka.ele('IdentifikacijskaStevilka').txt(invoice.payer.vat);
        }
        else{
            stranka.ele('Sifra').txt(invoice.index);
            stranka.ele('Naziv').txt(invoice.payer.title);
            stranka.ele('Naslov').txt('/');
            stranka.ele('PostnaStevilka').txt('PO');
            stranka.ele('NazivPoste').txt('/');
        }
        
        const temeljnica = temeljnice.ele('Temeljnica');
        const glavaTemeljnice = temeljnica.ele('GlavaTemeljnice');

        glavaTemeljnice.ele('SifraVrsteTemeljnice').txt('IR');
        glavaTemeljnice.ele('DatumTemeljnice').txt(invoice.issued.date);
        glavaTemeljnice.ele('OpisGlaveTemeljnice').txt('IR:'+invoice.premise.label + '-' + invoice.device.label + '-' + invoice.index); 

        const ddv = temeljnica.ele('DDV').ele('DDVVrstica');

        const DDVGlava = ddv.ele('DDVGlava');
        DDVGlava.ele('DatumDDV').txt(invoice.issued.date);
        DDVGlava.ele('KnjigaDDV').txt('IR');
        DDVGlava.ele('DatumKnjizenjaDDV').txt(invoice.issued.date);
        DDVGlava.ele('SifraStranke').txt(invoice.index);
        DDVGlava.ele('Listina').txt('IR:'+invoice.premise.label + '-' + invoice.device.label + '-' + invoice.index);
        DDVGlava.ele('DatumListine').txt(invoice.issued.date);

        const ddvStopnje = ddv.ele('DDVStopnje');

        let DDVStopnja = ddvStopnje.ele('DDVStopnja');
        DDVStopnja.ele('SifraStopnjeDDV').txt('Z');
        DDVStopnja.ele('StoritevOsnova').txt(netAmount);
        DDVStopnja.ele('StoritevDDV').txt(taxAmount);

        DDVStopnja = ddvStopnje.ele('DDVStopnja');
        DDVStopnja.ele('SifraStopnjeDDV').txt('N');
        DDVStopnja.ele('StoritevOsnova').txt(ttAmount);
        DDVStopnja.ele('StoritevDDV').txt('0');

        const vrsticeTemeljnice = temeljnica.ele('VrsticeTemeljnice');
        let VrsticaTemeljnice = vrsticeTemeljnice.ele('VrsticaTemeljnice');
        VrsticaTemeljnice.ele('DatumKnjizbe').txt(invoice.issued.date);
        VrsticaTemeljnice.ele('OpisVrsticeTemeljnice').txt('IR:'+invoice.premise.label + '-' + invoice.device.label + '-' + invoice.index);
        VrsticaTemeljnice.ele('SifraKonta').txt(kontoTerjatev);
        VrsticaTemeljnice.ele('SifraStranke').txt(invoice.index);
        VrsticaTemeljnice.ele('DatumZapadlosti').txt(invoice.issued.date);
        VrsticaTemeljnice.ele('DatumOpravljanja').txt(invoice.issued.date);
        VrsticaTemeljnice.ele('VezaZaPlacilo').txt(invoice.premise.label + '-' + invoice.device.label + '-' + invoice.index);
        VrsticaTemeljnice.ele('ZnesekVBremeVDenarniEnoti').txt(grossAmount);
        VrsticaTemeljnice.ele('ZnesekVBremeVDomaciDenarniEnoti').txt(grossAmount);

        VrsticaTemeljnice = vrsticeTemeljnice.ele('VrsticaTemeljnice');
        VrsticaTemeljnice.ele('DatumKnjizbe').txt(invoice.issued.date);
        VrsticaTemeljnice.ele('OpisVrsticeTemeljnice').txt('IR:'+invoice.premise.label + '-' + invoice.device.label + '-' + invoice.index);
        VrsticaTemeljnice.ele('SifraKonta').txt(kontoPrihodkov);
        VrsticaTemeljnice.ele('ZnesekVDobroVDenarniEnoti').txt(netAmount);
        VrsticaTemeljnice.ele('ZnesekVDobroVDomaciDenarniEnoti').txt(netAmount);

        VrsticaTemeljnice = vrsticeTemeljnice.ele('VrsticaTemeljnice');
        VrsticaTemeljnice.ele('DatumKnjizbe').txt(invoice.issued.date);
        VrsticaTemeljnice.ele('OpisVrsticeTemeljnice').txt('IR:'+invoice.premise.label + '-' + invoice.device.label + '-' + invoice.index);
        VrsticaTemeljnice.ele('SifraKonta').txt('26600');
        VrsticaTemeljnice.ele('ZnesekVDobroVDenarniEnoti').txt(ttAmount);
        VrsticaTemeljnice.ele('ZnesekVDobroVDomaciDenarniEnoti').txt(ttAmount);

        VrsticaTemeljnice = vrsticeTemeljnice.ele('VrsticaTemeljnice');
        VrsticaTemeljnice.ele('DatumKnjizbe').txt(invoice.issued.date);
        VrsticaTemeljnice.ele('OpisVrsticeTemeljnice').txt('IR:'+invoice.premise.label + '-' + invoice.device.label + '-' + invoice.index);
        VrsticaTemeljnice.ele('SifraKonta').txt('26001');
        VrsticaTemeljnice.ele('ZnesekVDobroVDenarniEnoti').txt(taxAmount);
        VrsticaTemeljnice.ele('ZnesekVDobroVDomaciDenarniEnoti').txt(taxAmount);

        VrsticaTemeljnice = vrsticeTemeljnice.ele('VrsticaTemeljnice');
        VrsticaTemeljnice.ele('DatumKnjizbe').txt(invoice.issued.date);
        VrsticaTemeljnice.ele('OpisVrsticeTemeljnice').txt('IR:'+invoice.premise.label + '-' + invoice.device.label + '-' + invoice.index);
        VrsticaTemeljnice.ele('SifraKonta').txt(kontoTerjatev);
        VrsticaTemeljnice.ele('SifraStranke').txt(invoice.index);
        VrsticaTemeljnice.ele('DatumZapadlosti').txt(invoice.issued.date);
        VrsticaTemeljnice.ele('DatumOpravljanja').txt(invoice.issued.date);
        VrsticaTemeljnice.ele('VezaZaPlacilo').txt(invoice.premise.label + '-' + invoice.device.label + '-' + invoice.index);
        VrsticaTemeljnice.ele('ZnesekVDobroVDenarniEnoti').txt(grossAmount);
        VrsticaTemeljnice.ele('ZnesekVDobroVDomaciDenarniEnoti').txt(grossAmount);
        
        VrsticaTemeljnice = vrsticeTemeljnice.ele('VrsticaTemeljnice');
        VrsticaTemeljnice.ele('DatumKnjizbe').txt(invoice.issued.date);
        VrsticaTemeljnice.ele('OpisVrsticeTemeljnice').txt('IR:'+invoice.premise.label + '-' + invoice.device.label + '-' + invoice.index);
        VrsticaTemeljnice.ele('SifraKonta').txt(kontoNaciniPlacila);
        VrsticaTemeljnice.ele('SifraStranke').txt(invoice.index);
        VrsticaTemeljnice.ele('DatumZapadlosti').txt(invoice.issued.date);
        VrsticaTemeljnice.ele('DatumOpravljanja').txt(invoice.issued.date);
        VrsticaTemeljnice.ele('VezaZaPlacilo').txt(invoice.premise.label + '-' + invoice.device.label + '-' + invoice.index);
        VrsticaTemeljnice.ele('ZnesekVBremeVDenarniEnoti').txt(grossAmount);
        VrsticaTemeljnice.ele('ZnesekVBremeVDomaciDenarniEnoti').txt(grossAmount);

    });
      
    const xmlString = xml.end({ pretty: true });
    console.log(xmlString);
    console.log("Downloading XML...");

    // Create a Blob from the XML string
    const blob = new Blob([xmlString], { type: 'text/xml' });

    // Create a URL for the Blob
    const url = URL.createObjectURL(blob);

    // Create a link element for downloading
    const a = document.createElement('a');
    a.href = url;
    a.download = 'invoices.xml'; // Set the filename for the downloaded file
    a.click();

    // Cleanup: remove the URL created for the Blob after downloading
    URL.revokeObjectURL(url);

  }